export default function SegmentControl({ options, value, onChange }) {
  return (
    <div className="bg-gray-100 rounded-full p-1 flex">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
            value === option.value
              ? 'bg-white text-tayo shadow-sm'
              : 'text-sub-text'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
